import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';


var dhtmlXTreeView = (function () {
    function dhtmlXTreeView(g) {
        var h = this;
        if (typeof g == "object" && g.tagName == null) {
            console.log(g, "---init-dhtmlXTreeView--");
        }
        else {
            g = { parent: g, clear: true };
        }
        this.base =
            typeof g.parent == "string"
                ? document.getElementById(g.parent)
                : g.parent;
        if (this.base != document.body) {
            while (this.base.childNodes.length > 0) {
                this.base.removeChild(this.base.lastChild);
            }
        }
        this.conf = {
            skin: g.skin ||
                window.dhx4.skin ||
                (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
                window.dhx4.skinDetect("dhxtreeview") ||
                "material",
            tree_id: window.dhx4.newId(),
            ofs: { w: 1, h: 0 },
            adjust_base: false,
            icons: this.icons[typeof g.iconset == "string" &&
                this.icons[g.iconset] != null &&
                this.icons[g.iconset].r == true
                ? g.iconset
                : "tree_native"],
            autoload: { url: null, mode: "id" },
            selected: {},
            ud: {},
            idx: { sign: 0, icon: 1, text: 2 },
            silent: false,
            is_mac: navigator.platform.match(/^mac/i) != null &&
                typeof window.addEventListener == "function",
            mac_cmd_key: false
        };
        this.setSkin(this.conf.skin);
        this.cont = document.createElement("DIV");
        this.cont.className = "dhxtreeview_cont";
        this.base.appendChild(this.cont);
        this.area = document.createElement("DIV");
        this.area.className = "dhxtreeview_area";
        this.cont.appendChild(this.area);
        this.cont.onclick = function (a) {
            a = a || event;
            h.callEvent("_onTreeClick", [a, { stop: false }]);
        };
        this.cont.ondblclick = function (l) {
            l = l || event;
            var a = l.target || l.srcElement;
            if (a.className.match(/dhxtreeview_item_label/) != null) {
                h._openCloseItem(a.parentNode.parentNode._itemId, true);
            }
        };
        this.items = {};
        this._openCloseItem = function (l, a) {
            if (this.callEvent("_onBeforeOpen", [l]) !== true) {
                return;
            }
            if (!(this.items[l].kids == true || this.items[l].kids_request == true)) {
                return false;
            }
            if (this.items[l].half_opened == true) {
                this.items[l].half_opened = false;
                this._signUpdate(l);
                return;
            }
            if (a && this.conf.transProp != false) {
                if (!this.items[l].transEv) {
                    this.items[l].item.lastChild.addEventListener(this.conf.transEv, this._doOnTrEnd);
                    this.items[l].transEv = true;
                }
                if (this.items[l].opened == true) {
                    this.items[l].transMode = "close";
                    this.items[l].item.lastChild.style.overflow = "hidden";
                    this.items[l].item.lastChild.style.height =
                        this.items[l].item.lastChild.childNodes[0].offsetHeight + "px";
                    window.setTimeout(function () {
                        h.items[l].item.lastChild.style[h.conf.transProp] =
                            h.conf.transValueHeight;
                        h.items[l].item.lastChild.style.height = "0px";
                        h.items[l].item.lastChild.style.opacity = "0";
                        h.items[l].opened = false;
                        h._iconUpdate(l);
                        h._signUpdate(l);
                    }, 50);
                }
                else {
                    this.items[l].transMode = "open";
                    this.items[l].item.lastChild.style[this.conf.transProp] = this.conf.transValueHeight;
                    this.items[l].item.lastChild.childNodes[0].style.display = "";
                    this.items[l].item.lastChild.style.overflow = "hidden";
                    this.items[l].item.lastChild.style.height =
                        this.items[l].item.lastChild.childNodes[0].offsetHeight + "px";
                    this.items[l].item.lastChild.style.opacity = "1";
                    this.items[l].opened = true;
                    this._iconUpdate(l);
                    this._signUpdate(l);
                }
            }
            else {
                this.items[l].opened = !this.items[l].opened;
                this.items[l].item.lastChild.style.display =
                    this.items[l].opened == true ? "" : "none";
                this.items[l].item.lastChild.childNodes[0].style.display = this.items[l].item.lastChild.style.display;
                this.items[l].item.lastChild.style.height =
                    this.items[l].opened == true ? "" : "0px";
                this.items[l].item.lastChild.style.opacity =
                    this.items[l].opened == true ? 1 : 0;
                this._iconUpdate(l);
                this._signUpdate(l);
                this._fixAreaWidth();
            }
        };
        this._doOnTrEnd = function () {
            var a = this.parentNode._itemId;
            h.items[a].item.lastChild.style[h.conf.transProp] = "";
            if (h.items[a].transMode == "close") {
                h.items[a].item.lastChild.childNodes[0].style.display = "none";
            }
            else {
                h.items[a].item.lastChild.style.height = "";
                h.items[a].item.lastChild.style.overflow = "";
            }
            h._fixAreaWidth();
        };
        this.setSizes();
        dhx4._eventable(this);
        var e = window.dhx4.transDetect();
        this.conf.transProp = e.transProp;
        this.conf.transEv = e.transEv;
        this.conf.transValueHeight = "height 0.15s";
        e = null;
        if (this.conf.is_mac == true) {
            this._macOnKey = function (a) {
                if (((window.dhx4.isKHTML ||
                    window.dhx4.isChrome ||
                    window.dhx4.isOpera) &&
                    (a.keyCode == 91 || a.keyCode == 93)) ||
                    (window.dhx4.isFF && a.keyCode == 224)) {
                    h.conf.mac_cmd_key = a.type == "keydown";
                }
            };
            window.addEventListener("keydown", this._macOnKey, false);
            window.addEventListener("keyup", this._macOnKey, false);
        }
        for (var c in this.modules) {
            if (this.modules[c].init != null) {
                this[this.modules[c].init](g);
            }
        }
        if (g.items != null || g.json != null || g.xml != null) {
            this.loadStruct(g.items || g.json || g.xml, g.onload);
        }
        return this;
    }
    dhtmlXTreeView.prototype._addItem = function (u, n, r, l) {
        var s = n != null ? this.items[n].level + 1 : 1;
        var m = document.createElement("DIV");
        m.className = "dhxtreeview_item";
        m.innerHTML = "<div class='dhxtreeview_item_text'></div>";
        if (l != null && l < 0) {
            r.index = 0;
        }
        var o = null;
        if (n == null) {
            o = this.area;
        }
        else {
            var a = this.items[n].kids;
            if (a == false) {
                this._initKidsNode(n);
            }
            this.items[n].kids_request = false;
            o = this.items[n].item.lastChild.firstChild;
        }
        if (l != null && o.childNodes[l] != null) {
            o.insertBefore(m, o.childNodes[l]);
        }
        else {
            o.appendChild(m);
        }
        o = null;
        m._itemId = u;
        m._treeId = this.conf.tree_id;
        if (window.dhx4.isIE == true) {
            m.onselectstart = function (v) {
                v = v || event;
                if (v.preventDefault) {
                    v.preventDefault();
                }
                else {
                    v.returnValue = false;
                }
            };
        }
        this.items[u] = {
            id: u,
            pId: n,
            treeId: this.conf.tree_id,
            text: r.text,
            item: m,
            level: s,
            kids: false,
            opened: window.dhx4.s2b(r.open),
            userdata: window.dhx4._copyObj(r.userdata || {}),
            half_opened: false
        };
        this.callEvent("_onItemRendered", [u, r]);
        m.firstChild.innerHTML = this._getItemHtml(u);
        m = null;
        if (window.dhx4.s2b(r.select) == true) {
            this._setSelected(u, true);
        }
        this.callEvent("_onItemInited", [u, r]);
    };
    dhtmlXTreeView.prototype.addItem = function (n, l, m, a) {
        if (this.items[n] != null) {
            return;
        }
        if (m != null && this.items[m] == null) {
            m = null;
        }
        this._addItem(n, m, { text: l }, a);
        this._callPublicEvent("onAddItem", [n, l, m, a]);
    };
    dhtmlXTreeView.prototype._removeSingleItem = function (m) {
        if (window.dhx4.isIE == true) {
            this.items[m].item.onselectstart = null;
        }
        this.items[m].item.parentNode.removeChild(this.items[m].item);
        for (var l in this.items[m]) {
            this.items[m][l] = null;
            delete this.items[m][l];
        }
        delete this.items[m];
        if (this.conf.selected[m] == true) {
            delete this.conf.selected[m];
        }
    };
    dhtmlXTreeView.prototype._removeItem = function (m) {
        for (var l in this.items) {
            if (this.items[l].pId == m) {
                this._removeItem(l);
            }
        }
        if (m != null) {
            this._removeSingleItem(m);
        }
    };
    dhtmlXTreeView.prototype.deleteItem = function (a) {
        if (this.items[a] == null) {
            return;
        }
        if (!this._callPublicEvent("onBeforeDeleteItem", [a])) {
            return;
        }
        this._removeItem(a);
        this._callPublicEvent("onDeleteItem", [a]);
    };
    dhtmlXTreeView.prototype.clearAll = function () {
        this._removeItem(null);
        if (this.conf.unloading != true) {
            this._fixAreaWidth();
        }
    };
    dhtmlXTreeView.prototype._initKidsNode = function (l) {
        var a;
        if (this.items[l].item.lastChild.className.match(/dhxtreeview_kids_cont/) ==
            null) {
            a = document.createElement("DIV");
            a.className = "dhxtreeview_kids_cont";
            a.innerHTML = "<div style='position:relative;'></div>";
            a.style.opacity = "1";
            if (this.items[l].opened != true) {
                if (this.conf.transProp != false) {
                    a.style.height = "0px";
                    a.style.opacity = "0";
                    a.firstChild.style.display = "none";
                }
                else {
                    a.style.display = "none";
                }
            }
            this.items[l].item.appendChild(a);
        }
        this.items[l].kids = true;
        this._iconUpdate(l);
        this._signUpdate(l);
        a = null;
    };
    dhtmlXTreeView.prototype._clearKidsNode = function (a) {
        if (this.items[a].item.lastChild.className.match(/dhxtreeview_kids_cont/) !=
            null) {
            this.items[a].item.removeChild(this.items[a].item.lastChild);
        }
        this.items[a].kids = false;
        this._iconUpdate(a);
        this._signUpdate(a);
    };
    dhtmlXTreeView.prototype.openItem = function (l, a) {
        if (this.items[l].opened != true) {
            if (typeof a == "undefined") {
                a = true;
            }
            this._openCloseItem(l, a);
        }
    };
    dhtmlXTreeView.prototype.closeItem = function (l, a) {
        if (this.items[l].opened == true) {
            if (typeof a == "undefined") {
                a = true;
            }
            this._openCloseItem(l, a);
        }
    };
    dhtmlXTreeView.prototype.setSizes = function () {
        if (this.conf.adjust_base == true) {
            this.base.style.width = this.base.parentNode.clientWidth - 2 + "px";
            this.base.style.height = this.base.parentNode.clientHeight - 2 + "px";
        }
        this.cont.style.left = this.conf.ofs.w + "px";
        this.cont.style.top = this.conf.ofs.h + "px";
        this.cont.style.width = this.base.clientWidth - this.conf.ofs.w * 2 + "px";
        this.cont.style.height =
            this.base.clientHeight - this.conf.ofs.h * 2 + "px";
        this._fixAreaWidth();
    };
    dhtmlXTreeView.prototype._fixAreaWidth = function (a) {
        var h = this;
        this.area.style.width = "100%";
        if (this.cont.scrollWidth != this.cont.clientWidth) {
            this.area.style.width = this.cont.scrollWidth + 1 + "px";
        }
        if (window.dhx4.isIE7 == true && a !== false) {
            window.setTimeout(function () {
                h._fixAreaWidth(false);
            }, 1);
        }
    };
    dhtmlXTreeView.prototype.unload = function () {
        var h = this;
        this.conf.unloading = true;
        this.cont.onclick = null;
        this.cont.ondblclick = null;
        this.clearAll();
        if (this.conf.is_mac == true) {
            window.removeEventListener("keydown", this._macOnKey, false);
            window.removeEventListener("keyup", this._macOnKey, false);
        }
        for (var l in this.modules) {
            if (this.modules[l].unload != null) {
                this[this.modules[l].unload]();
            }
        }
        this.area.parentNode.removeChild(this.area);
        this.area = null;
        this.cont.parentNode.removeChild(this.cont);
        this.cont = null;
        this.base.className = String(this.base.className).replace(new RegExp("s{0,}dhxtreeview_" + (this.conf.skin || "")), "");
        window.dhx4._eventable(this, "clear");
        for (var l_1 in this) {
            this[l_1] = null;
        }
        h = null;
    };
    return dhtmlXTreeView;
})();
dhtmlXTreeView.prototype.modules = {};
dhtmlXTreeView.prototype.setSkin = function (a) {
    this.base.className =
        String(this.base.className).replace(new RegExp("s{0,}dhxtreeview_" + (this.conf.skin || "")), "") +
            " dhxtreeview_" +
            a;
    this.conf.skin = a;
    this.conf.icon_width = dhx4.readFromCss("dhxtreeview_" + this.conf.skin + " dhxtreeview_icon_width");
    this.conf.ofs =
        this.conf.skin == "dhx_skyblue" ? { w: 1, h: 0 } : { w: 0, h: 0 };
};
dhtmlXTreeView.prototype.setItemText = function (c, a) {
    if (this.items[c] != null) {
        this.items[c].text = a;
        this.items[c].item.firstChild.childNodes[this.conf.idx.text].innerHTML = a;
        this._callPublicEvent("onTextChange", [c, a]);
    }
};
dhtmlXTreeView.prototype.getItemText = function (a) {
    return this.items[a].text;
};
dhtmlXTreeView.prototype.getParentId = function (a) {
    return this.items[a].pId;
};
dhtmlXTreeView.prototype.getSubItems = function (g) {
    var e = [];
    for (var c in this.items) {
        if (this.items[c].pId == g) {
            e.push(c);
        }
    }
    return e;
};
dhtmlXTreeView.prototype._refreshItemHtml = function (e, a, c) {
    this.items[e].item.firstChild.innerHTML = this._getItemHtml(e);
    if (a == true) {
        this._signUpdate(e);
    }
    if (c == true) {
        this._iconUpdate(e);
    }
};
dhtmlXTreeView.prototype._getItemHtml = function (l) {
    var e = [];
    var h = 0;
    for (var c in this.conf.idx) {
        var g = this["_itemHtml_" + c](l, h);
        if (g.nodeText !== false) {
            e.push(g.nodeText);
            h += g.nodeIndex;
        }
    }
    return e.join("");
};
dhtmlXTreeView.prototype._getIconOfs = function (c, a) {
    return (this.items[c].level - 1 + a) * this.conf.icon_width;
};
dhtmlXTreeView.prototype._itemHtml_text = function (c, a) {
    return {
        nodeIndex: 1,
        nodeText: "<div class='dhxtreeview_item_label' style='left:" +
            this._getIconOfs(c, a) +
            "px;'>" +
            this.items[c].text +
            "</div>"
    };
};
dhtmlXTreeView.prototype.setUserData = function (g, a, e) {
    var c = this.items[g];
    if (c) {
        c.userdata[a] = e;
    }
};
dhtmlXTreeView.prototype.getUserData = function (e, a) {
    var c = this.items[e];
    if (c && !a) {
        return c.userdata;
    }
    return c ? c.userdata[a] || null : null;
};
dhtmlXTreeView.prototype.silent = function (a) {
    this.conf.silent = true;
    if (typeof a == "function") {
        a.apply(window, [this]);
    }
    this.conf.silent = false;
};
dhtmlXTreeView.prototype._callPublicEvent = function () {
    return this.conf.silent == false
        ? this.callEvent.apply(this, arguments)
        : true;
};
dhtmlXTreeView.prototype.modules.chbx = { init: "_chbxInit" };
dhtmlXTreeView.prototype.enableCheckboxes = function (e) {
    e = e == true;
    if (this.conf.enable_chbx != e) {
        this.conf.enable_chbx = e;
        this._chbxUpdIndex();
        for (var c in this.items) {
            this._refreshItemHtml(c, true, true);
        }
    }
};
dhtmlXTreeView.prototype.getAllChecked = function (a) {
    return this._chbxGetCheckedBranch(a, true);
};
dhtmlXTreeView.prototype.getAllUnchecked = function (a) {
    return this._chbxGetCheckedBranch(a, false);
};
dhtmlXTreeView.prototype.checkItem = function (a) {
    this._chbxSetChecked(a, true, true);
};
dhtmlXTreeView.prototype.uncheckItem = function (a) {
    this._chbxSetChecked(a, false, true);
};
dhtmlXTreeView.prototype.isItemChecked = function (a) {
    if (this.items[a] == null) {
        return null;
    }
    return this.items[a].checked == true;
};
dhtmlXTreeView.prototype.enableCheckbox = function (a) {
    this._chbxSetEnabled(a, true);
};
dhtmlXTreeView.prototype.disableCheckbox = function (a) {
    this._chbxSetEnabled(a, false);
};
dhtmlXTreeView.prototype.isCheckboxEnabled = function (a) {
    return this.items[a].chbx_enabled == true;
};
dhtmlXTreeView.prototype.showCheckbox = function (a) {
    this._chbxSetVisible(a, true);
};
dhtmlXTreeView.prototype.hideCheckbox = function (a) {
    this._chbxSetVisible(a, false);
};
dhtmlXTreeView.prototype.isCheckboxVisible = function (a) {
    return this.items[a].chbx_visible == true;
};
dhtmlXTreeView.prototype._chbxInit = function (a) {
    this.enableCheckboxes(a.checkboxes);
    this.attachEvent("_onItemRendered", function (g, e) {

        var thisObj = this;
        thisObj.items[g].checked = window.dhx4.s2b(e.checked);
        var c = e.checkbox || "enabled,visible";
        thisObj.items[g].chbx_enabled = c.match(/disabled/) == null;
        thisObj.items[g].chbx_visible = c.match(/hidden/) == null;
    });
    this.attachEvent("_onTreeClick", function (h, c) {

        if (this.conf.enable_chbx != true) {
            return;
        }
        var g = h.target || h.srcElement;
        if (g.tagName.toLowerCase() == "i") {
            g = g.parentNode;
        }

        if ((g.parentNode.className || "").match(/dhxtreeview_item_text/) != null &&

            g == g.parentNode.childNodes[this.conf.idx.chbx]) {
            var l = g.parentNode.parentNode._itemId;

            if (this.items[l].chbx_enabled == true) {

                this._chbxSetChecked(l, !this.items[l].checked, true);
            }
            c.stop = true;
        }
    });
    a = null;
};
dhtmlXTreeView.prototype._itemHtml_chbx = function (e, c) {
    var a = { nodeIndex: 0, nodeText: false };
    if (this.conf.enable_chbx == true) {
        if (this.items[e].chbx_visible == true) {
            a.nodeIndex = 1;
        }
        a.nodeText =
            "<div class='dhxtreeview_item_icon' style='left:" +
                this._getIconOfs(e, c) +
                "px;" +
                (a.nodeIndex > 0 ? "" : "display:none;") +
                "'>" +
                this._chbxGenIcon(e) +
                "</div>";
    }
    return a;
};
dhtmlXTreeView.prototype._chbxSetChecked = function (c, a) {
    if (this.conf.enable_chbx != true) {
        return;
    }
    a = a == true;
    if (this.items[c].checked != a) {
        if (this._callPublicEvent("onBeforeCheck", [
            c,
            this.items[c].checked == true
        ]) !== true) {
            return;
        }
        this.items[c].checked = a;
        this.items[c].item.childNodes[0].childNodes[this.conf.idx.chbx].innerHTML = this._chbxGenIcon(c);
        this._callPublicEvent("onCheck", [c, a]);
    }
};
dhtmlXTreeView.prototype._chbxSetEnabled = function (c, a) {
    if (this.items[c].chbx_enabled != a) {
        this.items[c].chbx_enabled = a;
        this.items[c].item.firstChild.childNodes[this.conf.idx.chbx].innerHTML = this._chbxGenIcon(c);
    }
};
dhtmlXTreeView.prototype._chbxSetVisible = function (c, a) {
    if (this.items[c].chbx_visible != a) {
        this.items[c].chbx_visible = a;
        this._refreshItemHtml(c, true, true);
    }
};
dhtmlXTreeView.prototype._chbxGenIcon = function (c) {
    var a = this.conf.icons["chbx_" +
        (this.items[c].chbx_enabled ? "" : "dis_") +
        (this.items[c].checked ? "1" : "0")];
    return '<i class="' + this.conf.icons.prefix + " " + a + '"></i>';
};
dhtmlXTreeView.prototype._chbxUpdIndex = function () {
    if (this.conf.enable_chbx == true) {
        this.conf.idx = { sign: 0, chbx: 1, icon: 2, text: 3 };
    }
    else {
        this.conf.idx = { sign: 0, icon: 1, text: 2 };
    }
};
dhtmlXTreeView.prototype._chbxGetCheckedBranch = function (g, h) {
    var e = [];
    for (var c in this.items) {
        if (this.items[c].pId == g) {
            if (this.items[c].checked == h) {
                e.push(c);
            }
            if (this.items[c].kids == true) {
                e = e.concat(this._chbxGetCheckedBranch(c, h));
            }
        }
    }
    return e;
};
dhtmlXTreeView.prototype.modules.sign = { init: "_signInit" };
dhtmlXTreeView.prototype._signInit = function () {
    this.attachEvent("_onTreeClick", function (g, a) {
        if (a.stop == true) {
            return;
        }
        var c = g.target || g.srcElement;
        if (c.tagName.toLowerCase() == "i") {
            c = c.parentNode;
        }

        if ((c.parentNode.className || "").match(/dhxtreeview_item_text/) != null &&

            c == c.parentNode.childNodes[this.conf.idx.sign]) {

            this._openCloseItem(c.parentNode.parentNode._itemId, true);
            a.stop = true;
        }
    });
};
dhtmlXTreeView.prototype._signUpdate = function (e) {
    var c = this.items[e];
    var a = c.item.childNodes[0].childNodes[this.conf.idx.sign];
    if (c.kids == true || c.kids_request == true) {
        a.innerHTML =
            '<i class="' +
                this.conf.icons.prefix +
                " " +
                this.conf.icons[c.opened || c.half_opened ? "minus" : "plus"] +
                '"></i>';
    }
    else {
        a.innerHTML = "";
    }
    c = a = null;
};
dhtmlXTreeView.prototype._itemHtml_sign = function (c, a) {
    return {
        nodeIndex: 1,
        nodeText: "<div class='dhxtreeview_item_icon' style='left:" +
            this._getIconOfs(c, a) +
            "px;'></div>"
    };
};
dhtmlXTreeView.prototype.modules.selection = {
    init: "_selectionInit"
};
dhtmlXTreeView.prototype.selectItem = function (h) {
    if (this.conf.msel == true) {
        var e = {};
        if (!(h instanceof Array)) {
            h = [h];
        }
        for (var g = 0; g < h.length; g++) {
            e[h[g]] = true;
        }
        for (var c in this.conf.selected) {
            if (e[c] == true) {
                delete e[c];
            }
            else {
                this._setSelected(c, false);
            }
        }
        for (var c_1 in e) {
            this._setSelected(c_1, true);
        }
    }
    else {
        if (h != null && this.conf.selected[h] != true && !(h instanceof Array)) {
            if (this._clearSelection(h) == false) {
                this._setSelected(h, true);
            }
        }
    }
};
dhtmlXTreeView.prototype.unselectItem = function (c) {
    if (this.conf.msel == true) {
        if (!(c instanceof Array)) {
            c = [c];
        }
        for (var a = 0; a < c.length; a++) {
            if (this.conf.selected[c[a]] == true) {
                this._setSelected(c[a], false);
            }
        }
    }
    else {
        if (c != null) {
            this._setSelected(c, false);
        }
    }
};
dhtmlXTreeView.prototype.getSelectedId = function () {
    var e = [];
    for (var c in this.conf.selected) {
        e.push(c);
    }
    return this.conf.msel ? e : e[0] || null;
};
dhtmlXTreeView.prototype.enableMultiselect = function (a) {
    a = a == true;
    if (this.conf.msel != a) {
        this._clearSelection();
        this.conf.msel = a;
    }
};
dhtmlXTreeView.prototype._selectionInit = function (a) {
    this.conf.msel = window.dhx4.s2b(a.multiselect);
    this.attachEvent("_onTreeClick", function (l, c) {
        if (c.stop == true) {
            return;
        }
        var h = l.target || l.srcElement;
        if (h.tagName.toLowerCase() == "i") {
            h = h.parentNode;
        }
        var g = null;
        if (h.className.match(/dhxtreeview_item_label/) != null) {
            g = h.parentNode.parentNode._itemId;
        }
        else {
            if (h.className.match(/^dhxtreeview_item_text/) != null) {
                g = h.parentNode._itemId;
            }
            else {
                if (h.className.match(/^dhxtreeview_item_icon/) != null) {
                    g = h.parentNode.parentNode._itemId;
                }
            }
        }
        if (g != null) {

            if (this.conf.msel == true) {

                if (

                (l.ctrlKey == true || this.conf.mac_cmd_key == true) &&
                    l.shiftKey == false &&
                    l.altKey == false) {

                    this._setSelected(g, !this._isSelected(g));
                }
                else {

                    if (l.ctrlKey == false &&
                        l.shiftKey == false &&
                        l.altKey == false &&

                        this.conf.mac_cmd_key == false) {

                        if (this._clearSelection(g) == false) {

                            this._setSelected(g, true);
                        }
                    }
                }
            }
            else {

                if (this._clearSelection(g) == false) {

                    this._setSelected(g, true);
                }
            }
        }
    });
};
dhtmlXTreeView.prototype._setSelected = function (c, a) {
    if (a == true) {
        if (this.conf.selected[c] != true) {
            this.items[c].item.childNodes[0].className +=
                " dhxtreeview_item_text_selected";
            this.conf.selected[c] = true;
            this._callPublicEvent("onSelect", [c, true]);
        }
    }
    else {
        if (this.conf.selected[c] == true) {
            this.items[c].item.childNodes[0].className = String(this.items[c].item.childNodes[0].className).replace(/\s*dhxtreeview_item_text_selected/gi, "");
            delete this.conf.selected[c];
            this._callPublicEvent("onSelect", [c, false]);
        }
    }
};
dhtmlXTreeView.prototype._clearSelection = function (g) {
    var e = false;
    for (var c in this.conf.selected) {
        if (g != null && c == g) {
            e = true;
        }
        else {
            this._setSelected(c, false);
        }
    }
    return e;
};
dhtmlXTreeView.prototype._isSelected = function (a) {
    return this.conf.selected[a] == true;
};
dhtmlXTreeView.prototype.modules.icons = { init: "_iconModuleInit" };
dhtmlXTreeView.prototype.setItemIcons = function (g, e) {
    if (e == null && this.items[g].icons != null) {
        delete this.items[g].icons;
    }
    else {
        if (e != null) {
            if (this.items[g].icons == null) {
                this.items[g].icons = {};
            }
            for (var c in e) {
                if (e[c] != null) {
                    this.items[g].icons[c] = e[c];
                }
                else {
                    if (e[c] == null && this.items[g].icons[c] != null) {
                        delete this.items[g].icons[c];
                    }
                }
            }
        }
    }
    this._iconUpdate(g);
};
dhtmlXTreeView.prototype.setIconColor = function (e, a) {
    var c = this.items[e].item.firstChild.childNodes[this.conf.idx.icon]
        .firstChild;
    if (a == null) {
        if (this.items[e].icon_color != null) {
            delete this.items[e].icon_color;
            c.style.color = "inherit";
        }
    }
    else {
        if (this.items[e].icon_color != a) {
            this.items[e].icon_color = a;
            c.style.color = a;
        }
    }
    c = null;
};
dhtmlXTreeView.prototype.setIconset = function (a) {
    if (this.icons[a] != null && this.icons[a].r == true) {
        this.conf.icons = this.icons[a];
    }
};
dhtmlXTreeView.prototype._iconModuleInit = function () {
    this.attachEvent("_onItemRendered", function (c, a) {
        if (a.icons != null) {

            this.items[c].icons = a.icons;
        }
        if (a.icon_color != null) {

            this.items[c].icon_color = a.icon_color;
        }
    });
};
dhtmlXTreeView.prototype._iconConf = function (g) {
    var e = this.items[g].icons || {};
    for (var c in { folder_opened: 1, folder_closed: 1, file: 1 }) {
        if (typeof e[c] == "undefined") {
            e[c] = this.conf.icons[c];
        }
    }
    return e;
};
dhtmlXTreeView.prototype._iconHtml = function (e, c) {
    var a = ['class="' + this.conf.icons.prefix + " " + c + '"'];
    if (this.items[e].icon_color != null) {
        a.push('style="color:' + this.items[e].icon_color + ';"');
    }
    return "<i " + a.join(" ") + "></i>";
};
dhtmlXTreeView.prototype._itemHtml_icon = function (c, a) {
    return {
        nodeIndex: 1,
        nodeText: "<div class='dhxtreeview_item_icon' style='left:" +
            this._getIconOfs(c, a) +
            "px;'>" +
            this._iconHtml(c, this._iconConf(c).file) +
            "</div>"
    };
};
dhtmlXTreeView.prototype._iconUpdate = function (g) {
    var e = this.items[g];
    var c = this._iconConf(g);
    var a = e.kids == true || e.kids_request == true
        ? c[e.opened ? "folder_opened" : "folder_closed"]
        : c.file;
    e.item.childNodes[0].childNodes[this.conf.idx.icon].innerHTML = this._iconHtml(g, a);
    e = null;
};
dhtmlXTreeView.prototype.icons = {
    tree_native: {
        r: true,
        prefix: "dhxtreeview_icon",
        plus: "dhxtreeview_icon_plus",
        minus: "dhxtreeview_icon_minus",
        file: "dhxtreeview_icon_file",
        folder_opened: "dhxtreeview_icon_folder_opened",
        folder_closed: "dhxtreeview_icon_folder_closed",
        loading: "dhxtreeview_icon_loading",
        chbx_0: "dhxtreeview_icon_chbx_0",
        chbx_1: "dhxtreeview_icon_chbx_1",
        chbx_dis_0: "dhxtreeview_icon_chbx_dis_0",
        chbx_dis_1: "dhxtreeview_icon_chbx_dis_1"
    },
    font_awesome: {
        r: !(window.dhx4.isIE6 == true || window.dhx4.isIE7 == true),
        prefix: "fa",
        plus: "fa-caret-right",
        minus: "fa-caret-down",
        file: "fa-file-o",
        folder_opened: "fa-folder-open-o",
        folder_closed: "fa-folder-o",
        loading: "fa-refresh fa-spin",
        chbx_0: "fa-square-o",
        chbx_1: "fa-check-square-o",
        chbx_dis_0: "fa-square-o dhx-disabled",
        chbx_dis_1: "fa-check-square-o dhx-disabled"
    }
};
dhtmlXTreeView.prototype.modules.loading = {
    init: "_loadingInit",
    unload: "_loadingUnload"
};
dhtmlXTreeView.prototype._loadingInit = function (a) {
    window.dhx4._enableDataLoading(this, "_initObj", "_xmlToObj", "tree", {
        struct: true
    });
    this.conf.root_id =
        typeof a.root_id == "undefined" || a.root_id == null ? "0" : a.root_id;
    this._dhxdataload.onBeforeXLS = function (c) {
        if (this.conf.autoload.url == null) {
            this.conf.autoload.url = c;
        }
        return { url: c.replace(/\{id\}/gi, this.conf.root_id) };
    };
};
dhtmlXTreeView.prototype._loadingUnload = function () {
    window.dhx4._enableDataLoading(this, null, null, null, "clear");
};
dhtmlXTreeView.prototype._initObj = function (h, a, c, e) {
    for (var g = 0; g < h.length; g++) {
        var l = h[g].id;
        if (l == null) {
            l = "dhxtreeview_id_" + window.dhx4.newId();
        }
        if (this.items[l] == null) {
            this._addItem(l, c, h[g]);
        }
        if (h[g].items != null) {
            this._initObj(h[g].items, null, l, true);
        }
    }
    if (e != true) {
        this._fixAreaWidth();
    }
};
dhtmlXTreeView.prototype._xmlToObj = function (n, m) {
    if (m != true) {
        n = n.getElementsByTagName("tree")[0];
    }
    var h = [];
    for (var c = 0; c < n.childNodes.length; c++) {
        var g = n.childNodes[c];
        if ((g.tagName || "").toLowerCase() == "item") {
            var r = {};
            for (var o = 0; o < g.attributes.length; o++) {
                r[g.attributes[o].name] = g.attributes[o].value;
            }
            if (g.childNodes.length > 0) {
                var md = this._xmlToObj(g, true);
                if (md.length > 0) {
                    r.items = md;
                }
                for (var o_1 = 0; o_1 < g.childNodes.length; o_1++) {
                    var s = (g.childNodes[o_1].tagName || "").toLowerCase();
                    var jObj = { icons: 1, userdata: 1 };
                    if (jObj[s] == 1) {
                        if (r[s] == null) {
                            r[s] = {};
                        }
                        for (var l = 0; l < g.childNodes[o_1].attributes.length; l++) {
                            var a = g.childNodes[o_1].attributes[l].name;
                            if (r[s][a] == null) {
                                r[s][a] = g.childNodes[o_1].attributes[l].value;
                            }
                        }
                    }
                }
            }
            h.push(r);
        }
        g = null;
    }
    return h;
};
dhtmlXTreeView.prototype.modules.dnd = {
    init: "_dndInit",
    unload: "_dndUnload"
};
dhtmlXTreeView.prototype.enableDragAndDrop = function (a) {
    this.conf.enable_dnd = window.dhx4.s2b(a);
};
dhtmlXTreeView.prototype._dndInit = function (a) {
    var c = this;
    this.enableDragAndDrop(a.dnd);
    this.conf.dnd = null;
    this._dndOnMouseDown = function (n) {
        if (c.conf.enable_dnd != true) {
            return;
        }
        n = n || event;
        if (typeof n.button != "undefined" && n.button >= 2) {
            return false;
        }
        var o = null;
        var m = null;
        var l = n.target || n.srcElement;
        var h = window.dhx4.absLeft(l) +
            (typeof n.offsetX == "undefined" ? n.layerX : n.offsetX) -
            n.clientX;
        var g = window.dhx4.absTop(l) +
            (typeof n.offsetY == "undefined" ? n.layerY : n.offsetY) -
            n.clientY;
        while (l != null && l != c.cont) {
            if ((l.className || "").match(/dhxtreeview_item/) != null &&
                l._itemId != null) {
                o = l._itemId;
                m = l._treeId;
                l = null;
            }
            else {
                l = l.parentNode;
            }
        }
        l = null;
        if (o == null) {
            return;
        }
        c.conf.dnd = {
            inited: false,
            id: o,
            treeId: m,
            selected: c.conf.selected[o] == true,
            tid: null,
            drop: {},
            x: n.clientX,
            y: n.clientY,
            ofs_x: h,
            ofs_y: g,
            zi: window.dhx4.newId(),
            scroll: false,
            scroll_ofs: 5,
            scroll_time: 30,
            scroll_tm: null,
            kids: {},
            idx: {}
        };
        c._dndInitEvents();
    };
    this._dndOnMouseMove = function (u) {
        u = u || event;
        if (c.conf.dnd.inited != true) {
            if (Math.abs(c.conf.dnd.x - u.clientX) >= 15 ||
                Math.abs(c.conf.dnd.y - u.clientY) >= 15) {
                if (c._callPublicEvent("onBeforeDrag", [c.conf.dnd.id]) !== true) {
                    return;
                }
                c.conf.dnd.inited = true;
                c.cont.className += " dhxtreeview_dnd_mode";
                c._dndInitDraggedObj();
                c._dndCollectKids(c.conf.dnd.id);
                c._dndCollectIndexes(c.area);
                if (c._clearSelection(c.conf.dnd.id) == false) {
                    c._setSelected(c.conf.dnd.id, true);
                }
                c.items[c.conf.dnd.id].item.className += " dhxtreeview_item_dragged";
                document.body.className += " dhxtreeview_dnd_mode";
                c.conf.dnd.cont = {
                    x1: window.dhx4.absLeft(c.base),
                    y1: window.dhx4.absTop(c.base)
                };
                c.conf.dnd.cont.x2 = c.conf.dnd.cont.x1 + c.base.offsetWidth;
                c.conf.dnd.cont.y2 = c.conf.dnd.cont.y1 + c.base.offsetHeight;
            }
            else {
                return;
            }
        }
        c.conf.dnd.x = u.clientX;
        c.conf.dnd.y = u.clientY;
        c._dndAdjustDraggedObj();
        var m = true;
        if (c.cont.scrollHeight > c.cont.clientHeight) {
            if (c.conf.dnd.x >= c.conf.dnd.cont.x1 &&
                c.conf.dnd.x <= c.conf.dnd.cont.x2) {
                if (c.cont.scrollTop > 0 &&
                    c.conf.dnd.y >= c.conf.dnd.cont.y1 &&
                    c.conf.dnd.y <= c.conf.dnd.cont.y1 + 10) {
                    c._dndScroll("up");
                    m = false;
                }
                else {
                    if (c.cont.scrollTop + c.cont.clientHeight < c.cont.scrollHeight &&
                        c.conf.dnd.y <= c.conf.dnd.cont.y2 &&
                        c.conf.dnd.y >= c.conf.dnd.cont.y2 - 10) {
                        c._dndScroll("down");
                        m = false;
                    }
                }
            }
        }
        if (m == true && c.conf.dnd.scroll == true) {
            c._dndScroll("stop");
        }
        var w = u.target || u.srcElement;
        if (w.parentNode != null &&
            (w.parentNode.className || "").match(/dhxtreeview_kids_cont/) != null) {
            w = null;
            return;
        }
        var g = false;
        var n = null;
        var s = null;
        if (w.className != null) {
            if (w.className.match(/dhxtreeview_item_[li]/) != null) {
                n = w.parentNode.parentNode._itemId;
                s = w.parentNode.parentNode._treeId;
            }
            else {
                if (w.className.match(/dhxtreeview_item_[t]/) != null) {
                    n = w.parentNode._itemId;
                    s = w.parentNode._treeId;
                }
            }
        }
        if (n != null && s != c.conf.dnd.treeId) {
            return;
        }
        if (c.conf.dnd.id == n || c.conf.dnd.kids[n] == true) {
            n = null;
        }
        if (n != null) {
            var o = c.items[n].item.firstChild.offsetHeight;
            var v = Math.max(Math.floor((Math.min(u.layerY || u.offsetY, o) * 3) / o), 0);
            if (v == 0) {
                if (c.items[n].item.previousSibling == c.items[c.conf.dnd.id].item) {
                    v = null;
                }
            }
            else {
                if (v == 1) {
                    if (c.items[c.conf.dnd.id].pId == n) {
                        v = null;
                    }
                    else {
                        if (c.items[n].kids == true &&
                            c.items[n].item.lastChild.firstChild.firstChild ==
                                c.items[c.conf.dnd.id].item) {
                            v = null;
                        }
                    }
                }
                else {
                    if (v == 2) {
                        if (c.items[n].opened == true) {
                            v = null;
                        }
                        else {
                            if (c.items[n].item.nextSibling == c.items[c.conf.dnd.id].item) {
                                v = null;
                            }
                        }
                    }
                }
            }
            if (v != c.conf.dnd.ofs) {
                c.conf.dnd.ofs = v;
                g = true;
            }
        }
        if (n != c.conf.dnd.tid) {
            if (c.conf.dnd.tid != null) {
                c._dndUpdateTargetCss(c.conf.dnd.tid, false);
            }
            if (n != null) {
                g = true;
            }
            c.conf.dnd.tid = n;
        }
        if (g == true) {
            var r = false;
            if (v != null) {
                var l = {
                    id: c.conf.dnd.id,
                    pId: c.items[n].pId || null,
                    index: null,
                    idxOfs: c.items[c.conf.dnd.id].pId == c.items[n].pId &&
                        c.conf.dnd.idx[c.conf.dnd.id] < c.conf.dnd.idx[n]
                        ? -1
                        : 0
                };
                if (v == 0 || v == 2) {
                    l.index = c.conf.dnd.idx[n] + (v == 2 ? 1 : 0) + l.idxOfs;
                }
                else {
                    if (v == 1) {
                        l.pId = n;
                        l.index =
                            c.items[n].item.lastChild.className.match(/dhxtreeview_kids_cont/) == null
                                ? 0
                                : c.items[n].item.lastChild.firstChild.childNodes.length;
                    }
                }
                if (c.conf.dnd.drop.id != l.id ||
                    c.conf.dnd.drop.pId != l.pId ||
                    c.conf.dnd.drop.index != l.index) {
                    c.conf.dnd.drop = l;
                    if (c._callPublicEvent("onDragOver", [
                        c.conf.dnd.drop.id,
                        c.conf.dnd.drop.pId,
                        c.conf.dnd.drop.index
                    ]) === true) {
                        r = true;
                    }
                }
            }
            if (r != true) {
                c.conf.dnd.ofs = v = null;
            }
            c._dndUpdateTargetCss(n, r);
        }
    };
    this._dndOnMouseUp = function (r) {
        r = r || event;
        if (typeof r.button != "undefined" && r.button >= 2) {
            return;
        }
        c._dndUnloadEvents();
        c._dndUnloadDraggedObj();
        if (c.conf.dnd.scroll == true) {
            c._dndScroll("stop");
        }
        if (c.cont.className.match(/dhxtreeview_dnd_mode/gi) != null) {
            c.cont.className = String(c.cont.className).replace(/\s*dhxtreeview_dnd_mode/gi, "");
        }
        if (c.conf.dnd.tid != null) {
            c._dndUpdateTargetCss(c.conf.dnd.tid, false);
        }
        if (c.conf.dnd.inited == true) {
            c.items[c.conf.dnd.id].item.className = String(c.items[c.conf.dnd.id].item.className).replace(/\s*dhxtreeview_item_dragged/gi, "");
            document.body.className = String(document.body.className).replace(/\s*dhxtreeview_dnd_mode/, "");
            if (c.conf.dnd.tid != null && c.conf.dnd.ofs != null) {
                if (c._callPublicEvent("onBeforeDrop", [
                    c.conf.dnd.drop.id,
                    c.conf.dnd.drop.pId,
                    c.conf.dnd.drop.index
                ]) === true) {
                    var o = c.items[c.conf.dnd.id];
                    var h = c.items[c.conf.dnd.tid];
                    var l = o.pId != null ? c.items[o.pId] : null;
                    var n;
                    if (c.conf.dnd.ofs == 1) {
                        var m = false;
                        if (h.kids == false) {
                            c._initKidsNode(h.id);
                            m = true;
                        }
                        h.item.lastChild.firstChild.appendChild(o.item);
                        if (m == true) {
                            c._openCloseItem(h.id, false);
                        }
                        o.pId = h.id;
                        n = h.level + 1 - o.level;
                    }
                    else {
                        if (c.conf.dnd.ofs == 0 || c.conf.dnd.ofs == 2) {
                            if (c.conf.dnd.ofs == 0) {
                                h.item.parentNode.insertBefore(o.item, h.item);
                            }
                            else {
                                if (h.item.nextSibling != null) {
                                    h.item.parentNode.insertBefore(o.item, h.item.nextSibling);
                                }
                                else {
                                    h.item.parentNode.appendChild(o.item);
                                }
                            }
                            o.pId = h.pId;
                            n = h.level - o.level;
                        }
                    }
                    if (n != 0) {
                        c.conf.dnd.kids[o.id] = true;
                        for (var g in c.conf.dnd.kids) {
                            c.items[g].level += n;
                            c._refreshItemHtml(g, c.items[g].kids == true, true);
                        }
                    }
                    if (l != null &&
                        l.kids == true &&
                        l.item.lastChild.firstChild.childNodes.length == 0) {
                        c._clearKidsNode(l.id);
                        l.opened = false;
                    }
                    o = h = l = null;
                    c._fixAreaWidth();
                    c._callPublicEvent("onDrop", [
                        c.conf.dnd.drop.id,
                        c.conf.dnd.drop.pId,
                        c.conf.dnd.drop.index
                    ]);
                }
            }
        }
        window.dhx4.zim.clear(c.conf.dnd.zi);
        c.conf.dnd = null;
    };
    this._dndOnContextMenu = function (g) {
        if (c.conf.dnd.inited == true) {
            g = g || event;
            g.cancelBubble = true;
            if (g.preventDefault) {
                g.preventDefault();
            }
            g.returnValue = false;
            return false;
        }
    };
    this._dndInitEvents = function () {
        if (typeof window.addEventListener == "function") {
            window.addEventListener("mousemove", this._dndOnMouseMove, false);
            window.addEventListener("mouseup", this._dndOnMouseUp, false);
            window.addEventListener("contextmenu", this._dndOnContextMenu, false);
        }
        else {
            document.body.attachEvent("onmousemove", this._dndOnMouseMove);
            document.body.attachEvent("onmouseup", this._dndOnMouseUp);
            document.body.attachEvent("oncontextmenu", this._dndOnContextMenu);
        }
    };
    this._dndUnloadEvents = function () {
        if (typeof window.addEventListener == "function") {
            window.removeEventListener("mousemove", this._dndOnMouseMove, false);
            window.removeEventListener("mouseup", this._dndOnMouseUp, false);
            window.removeEventListener("contextmenu", this._dndOnContextMenu, false);
        }
        else {
            document.body.detachEvent("onmousemove", this._dndOnMouseMove);
            document.body.detachEvent("onmouseup", this._dndOnMouseUp);
            document.body.detachEvent("oncontextmenu", this._dndOnContextMenu);
        }
    };
    this._dndInitDraggedObj = function () {
        this.conf.dnd.dragged = document.createElement("DIV");
        this.conf.dnd.dragged.className =
            "dhxtreeview_dragged_obj_" + this.conf.skin;
        this.conf.dnd.dragged.style.zIndex = window.dhx4.zim.reserve(this.conf.dnd.zi);
        document.body.appendChild(this.conf.dnd.dragged);
        this.conf.dnd.dragged.innerHTML = this.getItemText(this.conf.dnd.id);
    };
    this._dndAdjustDraggedObj = function () {
        this.conf.dnd.dragged.style.left =
            this.conf.dnd.x + this.conf.dnd.ofs_x + 12 + "px";
        this.conf.dnd.dragged.style.top =
            this.conf.dnd.y + this.conf.dnd.ofs_y + 18 + "px";
    };
    this._dndUnloadDraggedObj = function () {
        if (this.conf.dnd.dragged != null) {
            document.body.removeChild(this.conf.dnd.dragged);
            this.conf.dnd.dragged = null;
        }
    };
    this._dndUpdateTargetCss = function (l, h) {
        var g = this.items[l].item.childNodes[0];
        if (this.conf.dnd.ofs == null) {
            h = false;
        }
        if (h == true) {
            g.className = String(g.className).replace(/(\s*dhxtreeview_drop_\d)?$/i, " dhxtreeview_drop_" + this.conf.dnd.ofs);
            if (g.nextSibling == null ||
                g.nextSibling.className.match(/dhxtreeview_drop_preview/) == null) {
                var e = document.createElement("DIV");
                e.className = "dhxtreeview_drop_preview";
                e.style.left = g.lastChild.previousSibling.style.left;
                if (g.nextSibling == null) {
                    g.parentNode.appendChild(e);
                }
                else {
                    g.parentNode.insertBefore(e, g.nextSibling);
                }
                e = null;
            }
            g.nextSibling.className = String(g.nextSibling.className).replace(/(\s*dhxtreeview_drop_\d)?$/i, " dhxtreeview_drop_" + this.conf.dnd.ofs);
        }
        else {
            if (g.className.match(/dhxtreeview_drop_\d/) != null) {
                g.className = String(g.className).replace(/\s*dhxtreeview_drop_\d/gi, "");
                if (g.nextSibling != null &&
                    g.nextSibling.className.match(/dhxtreeview_drop_preview/) != null) {
                    g.parentNode.removeChild(g.nextSibling);
                }
            }
        }
        g = null;
    };
    this._dndCollectKids = function (g) {
        for (var e in this.items) {
            if (this.items[e].pId == g) {
                this.conf.dnd.kids[e] = true;
                if (this.items[e].kids == true) {
                    this._dndCollectKids(e);
                }
            }
        }
    };
    this._dndCollectIndexes = function (e) {
        for (var g = 0; g < e.childNodes.length; g++) {
            this.conf.dnd.idx[e.childNodes[g]._itemId] = g;
            if (e.childNodes[g].lastChild.className.match(/dhxtreeview_kids_cont/) !=
                null) {
                this._dndCollectIndexes(e.childNodes[g].lastChild.firstChild);
            }
        }
    };
    this._dndScroll = function (h, g) {
        if (h == "stop") {
            if (c.conf.dnd.scroll == true) {
                if (c.conf.dnd.scroll_tm) {
                    window.clearTimeout(c.conf.dnd.scroll_tm);
                }
                c.conf.dnd.scroll = false;
            }
            return;
        }
        else {
            if (c.conf.dnd.scroll == true) {
                if (g != true) {
                    return;
                }
            }
            else {
                c.conf.dnd.scroll = true;
            }
            var e = false;
            if (h == "up") {
                c.cont.scrollTop = Math.max(0, c.cont.scrollTop - c.conf.dnd.scroll_ofs);
                if (c.cont.scrollTop == 0) {
                    e = true;
                }
            }
            else {
                c.cont.scrollTop = Math.min(c.cont.scrollHeight - c.cont.clientHeight, c.cont.scrollTop + c.conf.dnd.scroll_ofs);
                if (c.cont.scrollTop + c.cont.clientHeight == c.cont.scrollHeight) {
                    e = true;
                }
            }
            if (e != true) {
                c.conf.dnd.scroll_tm = window.setTimeout(function () {
                    c._dndScroll(h, true);
                }, c.conf.dnd.scroll_time);
            }
        }
    };
    if (typeof window.addEventListener == "function") {
        this.cont.addEventListener("mousedown", this._dndOnMouseDown, false);
    }
    else {
        this.cont.attachEvent("onmousedown", this._dndOnMouseDown);
    }
    this._dndUnload = function () {
        if (typeof window.addEventListener == "function") {
            this.cont.removeEventListener("mousedown", this._dndOnMouseDown, false);
        }
        else {
            this.cont.detachEvent("onmousedown", this._dndOnMouseDown);
        }
        c = null;
    };
    a = null;
};
dhtmlXTreeView.prototype.modules.ctx = {
    init: "_ctxInit",
    unload: "_ctxUnload"
};
dhtmlXTreeView.prototype.enableContextMenu = function (a) {
    this.conf.ctx = window.dhx4.s2b(a);
};
dhtmlXTreeView.prototype._ctxInit = function (a) {
    var c = this;
    this._ctxCall = function (l) {
        if (c.conf.ctx != true) {
            return;
        }
        l = l || event;
        var h = l.target || l.srcElement;
        if (h.tagName.toLowerCase() == "i") {
            h = h.parentNode;
        }
        var n = h.parentNode._itemId || h.parentNode.parentNode._itemId;
        var g = window.dhx4.absLeft(h) +
            (typeof l.offsetX == "undefined" ? l.layerX : l.offsetX);
        var m = window.dhx4.absTop(h) +
            (typeof l.offsetY == "undefined" ? l.layerY : l.offsetY);
        if (n != null &&
            c._callPublicEvent("onContextMenu", [n, g, m, l]) !== true) {
            if (l.preventDefault) {
                l.preventDefault();
            }
            l.cancelBubble = true;
            l.returnValue = false;
            return false;
        }
    };
    if (typeof window.addEventListener == "function") {
        this.cont.addEventListener("contextmenu", this._ctxCall, false);
    }
    else {
        this.cont.attachEvent("oncontextmenu", this._ctxCall);
    }
    this._ctxUnload = function () {
        if (typeof window.addEventListener == "function") {
            this.cont.removeEventListener("contextmenu", this._ctxCall, false);
        }
        else {
            this.cont.detachEvent("oncontextmenu", this._ctxCall);
        }
        c = null;
    };
    this.enableContextMenu(a.context_menu);
};
dhtmlXTreeView.prototype.modules.dynload = { init: "_dynLoadInit" };
dhtmlXTreeView.prototype._dynLoadInit = function () {
    this.attachEvent("_onItemInited", function (e, c) {

        this.items[e].kids_request = window.dhx4.s2b(c.kids);

        if (this.items[e].kids_request == true) {

            this._initKidsNode(e);
        }

        if (this.items[e].opened == true && this.items[e].kids_request == true) {

            var a = this;
            window.setTimeout(function () {
                a._dynLoadRequest(e);
                a = null;
            }, 100);
        }
    });
    this.attachEvent("_onBeforeOpen", function (a) {

        if (this.items[a].opened != true && this.items[a].kids_request == true) {

            if (this._dynLoadRequest(a) != true) {

                this.items[a].half_opened = true;

                this._signUpdate(a);
                return false;
            }
        }
        return true;
    });
};
dhtmlXTreeView.prototype._dynLoadRequest = function (c) {
    if (typeof this.conf.autoload.mode == "function") {
        this.conf.autoload.mode.apply(window, [c]);
        return true;
    }
    if (this.conf.autoload.url == null) {
        return;
    }
    this._dhxdataload.onBeforeXLS = function (e) {
        return { url: e.replace(/\{id\}/gi, c) };
    };
    var a = this;
    this.items[c].kids_loading_tm = window.setTimeout(function () {
        a._dynLoadUpdateIcon(c, true);
        a = null;
    }, 100);
    this.loadStruct(this.conf.autoload.url, function () {

        window.clearTimeout(this.items[c].kids_loading_tm);

        this._dynLoadUpdateIcon(c, false);

        if (this.items[c].half_opened) {

            this.items[c].half_opened = false;

            this._openCloseItem(c, true);
        }
    });
    this.items[c].kids_request = false;
    return false;
};
dhtmlXTreeView.prototype._dynLoadUpdateIcon = function (c, a) {
    this.items[c].loading = a == true;
    if (this.items[c].loading == true) {
        this.items[c].item.childNodes[0].childNodes[this.conf.idx.icon].innerHTML =
            "<i class='" +
                this.conf.icons.prefix +
                " " +
                this.conf.icons.loading +
                "'></i>";
    }
    else {
        this._iconUpdate(c);
    }
};

export default  dhtmlXTreeView;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeView/dhtmlXTreeView.js